import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Broker, BrokerSubscriber, Storage } from '@c4/core';
import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs/Subscriber';
import { ConnectedDeviceService } from './connected-device.service';

export interface discoveredDevice {
  host : string;
  address : string;
  isCustom : boolean;
}
export interface discoveredDevices {
  discoveredDevices?: discoveredDevice[];
  discoveredDevicesFilter: string;
}

export const DISCOVERY_UPDATE = "SYSMAN_DISCOVERY_UPDATE";
export const DISCOVERY_FILTER_UPDATE = "SYSMAN_DISCOVERY_FILTER_UPDATE";

export const discoveryReducer = (state: discoveredDevices, {type, payload}): discoveredDevices => {
  switch (type) {
    case DISCOVERY_FILTER_UPDATE: 
      return Object.assign({}, state, { discoveredDevicesFilter: payload });
    
    case DISCOVERY_UPDATE:
      return Object.assign({}, state, { discoveredDevices: payload });

    default:
      return state;
  }
}

@Injectable()
export class DiscoveryService {

  devicesSubscriber: BrokerSubscriber<any>;

  constructor(private broker: Broker, private storage: Storage, protected store: Store<any>, 
              protected connectedDeviceService: ConnectedDeviceService) {}

  public startDiscovery() {

    console.log('DiscoveryService.startDiscovery()');
    this.connectedDeviceService.setWorking(true);
    this.broker.subscribe({
            method: 'GET',
            path: '/api/v1/ssdp/devices'
        }).then(
        (result : any) => {
            this.devicesSubscriber = result;
            this.devicesSubscriber.subscribe(data => {
                // console.log('DiscoveryService.startDiscovery() subscription:', data); 
                this.connectedDeviceService.setWorking(false);
                this.store.dispatch({
                  type: DISCOVERY_UPDATE,
                  payload: {
                    devices: data
                  }
                });
            },
            (err : any) => {
                this.connectedDeviceService.setWorking(false);
                console.log('DiscoveryService.startDiscovery() error', err);
            }),
        (err : any) => {
            this.connectedDeviceService.setWorking(false);
            console.log('DiscoveryService.startDiscovery() error', err);             
        }
        });
  }

  public refreshDiscovery() {
    console.log('DiscoveryService.refreshDiscovery()');
    this.stopDiscovery();
    this.startDiscovery();
  }

  public stopDiscovery() {
    console.log('DiscoveryService.stopDiscovery()');
    if (this.devicesSubscriber) {
      this.devicesSubscriber.unsubscribe();
      this.devicesSubscriber = null;
    }

    this.store.dispatch({
      type: DISCOVERY_UPDATE,
      payload: {
        devices: {}
      }
    });
  }

  public updateFilter(filter:string) {
      this.store.dispatch({
        type: DISCOVERY_FILTER_UPDATE,
        payload: {
          filter
        }
      });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/services/discovery.service.ts